import { useState } from "react";
import time from "src/utils/time";
import { useTranslation } from "react-i18next";
import ListButton from "src/components/ListButton";
import { ReactComponent as TimerIcon } from "./timer-outlined.svg";
import LullabyPlayerTimerSettings from "./LullabyPlayerTimerSettings";

export default function LullabyPlayerTimer({
  onSubmit,
  timerSettings,
  disabled
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { enabled, duration } = timerSettings;
  return (
    <>
      <ListButton
        disabled={disabled}
        onClick={() => setIsOpen(true)}
        label={t("timer")}
        additionalText={
          enabled ? time.duration(duration).format("h _ m _") : t("off")
        }
        icon={TimerIcon}
        size="20px"
        iconFill="primary"
      />
      {isOpen && (
        <LullabyPlayerTimerSettings
          onClose={() => setIsOpen(false)}
          onSubmit={onSubmit}
          duration={duration}
          enabled={enabled}
        />
      )}
    </>
  );
}
